import { Form, Select, Input, Button } from 'antd';
import { FormInstance } from 'antd/es/form';
import FormSection from '../FormSection';
import CurvDown from '../svg/CurvDown';

const { Option } = Select;

interface HarassmentProps {
  form: FormInstance;
  isViewMode?: boolean;
}

const Harassment: React.FC<HarassmentProps> = ({ form, isViewMode }) => {
  const isView = isViewMode || new URLSearchParams(window.location.search).get('view') === 'true';
  const yesNoOptions = ['Yes', 'No'];
  const symptomsConfirmedByOptions = [
    'Physician',
    'Nurse'
  ];

  return (
    <div className="flex flex-col w-full h-full harassment-page-container">
      <style dangerouslySetInnerHTML={{
        __html: `
        .harassment-page-container .ant-form-item-label {
          margin-bottom: 16px !important;
          min-height: 30px !important;
        }
      `}} />
      <FormSection title="Harassment" columns={1} marginBottom="mb-[31px] md:mb-0">
        <div className="flex flex-col gap-[45px] md:gap-[62px] ">
          <Form.Item
            label="Did you have tangible, confirmed, physical, mental or emotional symptoms as a direct result of the accused's treatment?"
            name={['harassment_info', 'had_symptoms']}
            className="mb-0 w-full md:w-[33%]"
          >
            <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
              {yesNoOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>

          <div className="mt-2">
            <Form.List name={['harassment_info', 'symptoms']} initialValue={[]}>
              {(fields, { add, remove }) => (
                <div className="flex flex-col gap-0 w-full">
                  <div className="flex items-center justify-between mb-[24px] md:mb-4 w-full md:w-[34%]">
                    <h3 className="font-['Lexend',sans-serif] text-[14px] lg:text-[18px] font-medium text-[#1F2A37] leading-[29px] m-0">
                      List up to 3 of the symptoms
                    </h3>
                    <Button
                      type="text"
                      htmlType="button"
                      onClick={() => add()}
                      disabled={fields.length >= 3 || isViewMode}
                      className="flex items-center gap-2 text-[#4682B4] font-['Lexend',sans-serif] p-0 disabled:opacity-50"
                    >
                      <span className="text-[18px] leading-none">+</span> Add More
                    </Button>
                  </div>

                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className="flex flex-row items-start gap-4 md:gap-x-[18px] w-full md:w-[38%] mb-4">
                      {/* Number */}
                      <div className="w-8 flex justify-center pt-[12px]">
                        <span className="font-['Lexend',sans-serif] text-[16px] md:text-[18px] text-[#1F2A37A1] font-medium">
                          {String(name + 1).padStart(2, '0')}
                        </span>
                      </div>

                      {/* Symptom Input */}
                      <div className="flex-1 max-w-[600px]">
                        <Form.Item
                          {...restField}
                          name={[name, 'symptom']}
                          className="mb-0"
                          rules={[{ required: true, message: 'Please enter a symptom!' }]}
                        >
                          <Input placeholder="Enter Symptom" />
                        </Form.Item>
                      </div>

                      {/* Delete */}
                      <div className="w-10 flex justify-center pt-[12px]">
                        <button
                          onClick={() => {
                            if (!isView) {
                              remove(name);
                            }
                          }}
                          disabled={isView}
                          type="button"
                          style={isView ? { pointerEvents: 'none', opacity: 0.3, cursor: 'not-allowed' } : undefined}
                          className="p-1 text-[#6FB6F2] hover:text-red-500 transition-colors border-none bg-transparent cursor-pointer pl-[6px] disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                        >
                          <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-[18px] h-[20px] stroke-current">
                            <path d="M1 4h14M2 4v11a2 2 0 002 2h8a2 2 0 002-2V4M5 4V2a1 1 0 011-1h4a1 1 0 011 1v2M6.5 8v5M9.5 8v5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Form.List>
          </div>

          <Form.Item
            label="The Symptoms were confirmed by:"
            name={['harassment_info', 'symptoms_confirmed_by']}
            className="mb-4 w-full md:w-[33%]"
          >
            <Select placeholder="Select" suffixIcon={<CurvDown className="pt-[10px] md:pt-[14px]" />}>
              {symptomsConfirmedByOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}

            </Select>
          </Form.Item>
        </div>
      </FormSection>
    </div>
  );
};

export default Harassment;

